import { render, staticRenderFns } from "./mainFooter.vue?vue&type=template&id=d94b99ce&"
import script from "./mainFooter.vue?vue&type=script&lang=js&"
export * from "./mainFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports